import { useEffect, useState } from "react";
import { api } from "./api";

export const errMsg = (t, e) => {
  const d = e?.response?.data?.detail;
  if (typeof d !== "string") return t("common.error");
  const [code, m] = d.split(":");
  const key = `x.err.${code}`;
  const txt = t(key, { m });
  return txt === key ? t("common.error") : txt;
};

export const downloadFile = async (url, params, filename) => {
  const r = await api.get(url, { params, responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
};

export const openFile = async (fileId) => {
  const r = await api.get(`/files/${fileId}`, { responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank", "noopener");
};

export const useBlobUrl = (fileId) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!fileId) return undefined;
    let href;
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => { href = URL.createObjectURL(r.data); setUrl(href); }).catch(() => setUrl(null));
    return () => { if (href) URL.revokeObjectURL(href); };
  }, [fileId]);
  return url;
};

export const pct = (v) => (v == null ? "—" : `${String(v).replace(".", ",")}%`);
export const hours = (min) => `${Math.floor(min / 60)}:${String(min % 60).padStart(2, "0")}`;
export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
export const mondayOf = (iso) => {
  const d = new Date(`${iso}T12:00:00Z`);
  return addDays(iso, -((d.getUTCDay() + 6) % 7));
};
